<script lang="ts">
  let counter = 0
</script>

<script setup lang="ts">
  const id = counter++
  const gradientId = `sparkle-gradient-${id}`
  const clipId = `sparkle-clip-${id}`
</script>

<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g :clip-path="`url(#${clipId})`">
      <path
        d="M10.0002 3.33333L12.6668 6M3.3335 4V6.66667M12.6668 9.33333V12M6.66683 1.33333V2.66667M4.66683 5.33333H2.00016M14.0002 10.6667H11.3335M7.3335 2H6.00016M14.1161 4.54126C14.4686 4.18888 14.6666 3.71091 14.6667 3.2125C14.6668 2.71409 14.4688 2.23607 14.1165 1.8836C13.7641 1.53112 13.2861 1.33307 12.7877 1.33301C12.2893 1.33295 11.8113 1.53088 11.4588 1.88326L2.56145 10.7826C2.40667 10.9369 2.29219 11.127 2.22812 11.3359L1.34745 14.2373C1.33022 14.2949 1.32892 14.3562 1.34369 14.4145C1.35845 14.4728 1.38873 14.5261 1.43132 14.5686C1.4739 14.6111 1.5272 14.6413 1.58556 14.656C1.64392 14.6707 1.70516 14.6693 1.76279 14.6519L4.66479 13.7719C4.87357 13.7084 5.06357 13.5947 5.21812 13.4406L14.1161 4.54126Z"
        :stroke="`url(#${gradientId})`"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        :id="gradientId"
        x1="1.3335"
        y1="7.99952"
        x2="14.6667"
        y2="7.99952"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EF469B" />
        <stop
          offset="1"
          stop-color="#9333EA"
        />
      </linearGradient>
      <clipPath :id="clipId">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
